import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewsletterSignupComponent } from '../../newsletter-signup/newsletter-signup.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, NewsletterSignupComponent],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {}
